var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n3 = 0, F = function F() {}; return { s: F, n: function n() { return _n3 >= r.length ? { done: !0 } : { done: !1, value: r[_n3++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
!function (t) {
  var e = t.en = t.en || {};
  e.dictionary = Object.assign(e.dictionary || {}, {
    "Decrease indent": "Decrease indent",
    "Increase indent": "Increase indent"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
function () {
  var t = {
      704: function _(t, e, n) {
        t.exports = n(79)("./src/core.js");
      },
      492: function _(t, e, n) {
        t.exports = n(79)("./src/engine.js");
      },
      273: function _(t, e, n) {
        t.exports = n(79)("./src/ui.js");
      },
      209: function _(t, e, n) {
        t.exports = n(79)("./src/utils.js");
      },
      79: function _(t) {
        "use strict";

        t.exports = CKEditor5.dll;
      }
    },
    e = {};
  function n(s) {
    var i = e[s];
    if (void 0 !== i) return i.exports;
    var o = e[s] = {
      exports: {}
    };
    return t[s](o, o.exports, n), o.exports;
  }
  n.d = function (t, e) {
    for (var s in e) n.o(e, s) && !n.o(t, s) && Object.defineProperty(t, s, {
      enumerable: !0,
      get: e[s]
    });
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  };
  var s = {};
  (function () {
    "use strict";

    n.r(s), n.d(s, {
      Indent: function Indent() {
        return a;
      },
      IndentBlock: function IndentBlock() {
        return f;
      },
      IndentEditing: function IndentEditing() {
        return e;
      },
      IndentUI: function IndentUI() {
        return d;
      }
    });
    var t = n(704);
    var e = /*#__PURE__*/function (_t$Plugin) {
      _inherits(e, _t$Plugin);
      function e() {
        _classCallCheck(this, e);
        return _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
      }
      _createClass(e, [{
        key: "init",
        value: function init() {
          var e = this.editor;
          e.commands.add("indent", new t.MultiCommand(e)), e.commands.add("outdent", new t.MultiCommand(e));
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "IndentEditing";
        }
      }]);
      return e;
    }(t.Plugin);
    var i = n(273);
    var o = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>',
      r = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';
    var d = /*#__PURE__*/function (_t$Plugin2) {
      _inherits(d, _t$Plugin2);
      function d() {
        _classCallCheck(this, d);
        return _possibleConstructorReturn(this, _getPrototypeOf(d).apply(this, arguments));
      }
      _createClass(d, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.locale,
            n = t.t,
            s = "ltr" == e.uiLanguageDirection ? o : r,
            i = "ltr" == e.uiLanguageDirection ? r : o;
          this._defineButton("indent", n("Increase indent"), s), this._defineButton("outdent", n("Decrease indent"), i);
        }
      }, {
        key: "_defineButton",
        value: function _defineButton(t, e, n) {
          var _this = this;
          var s = this.editor;
          s.ui.componentFactory.add(t, function (o) {
            var r = s.commands.get(t),
              d = new i.ButtonView(o);
            return d.set({
              label: e,
              icon: n,
              tooltip: !0
            }), d.bind("isOn", "isEnabled").to(r, "value", "isEnabled"), _this.listenTo(d, "execute", function () {
              s.execute(t), s.editing.view.focus();
            }), d;
          });
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "IndentUI";
        }
      }]);
      return d;
    }(t.Plugin);
    var a = /*#__PURE__*/function (_t$Plugin3) {
      _inherits(a, _t$Plugin3);
      function a() {
        _classCallCheck(this, a);
        return _possibleConstructorReturn(this, _getPrototypeOf(a).apply(this, arguments));
      }
      _createClass(a, null, [{
        key: "pluginName",
        get: function get() {
          return "Indent";
        }
      }, {
        key: "requires",
        get: function get() {
          return [e, d];
        }
      }]);
      return a;
    }(t.Plugin);
    var c = n(492),
      l = n(209);
    var u = /*#__PURE__*/function (_t$Command) {
      _inherits(u, _t$Command);
      function u(t, e) {
        var _this2;
        _classCallCheck(this, u);
        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, t)), _this2._indentBehavior = e;
        return _this2;
      }
      _createClass(u, [{
        key: "refresh",
        value: function refresh() {
          var t = this.editor.model,
            e = (0, l.first)(t.document.selection.getSelectedBlocks());
          e && t.schema.checkAttribute(e, "blockIndent") ? this.isEnabled = this._indentBehavior.checkEnabled(e.getAttribute("blockIndent")) : this.isEnabled = !1;
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this3 = this;
          var t = this.editor.model,
            e = function (t) {
              var e = t.document.selection,
                n = t.schema;
              return Array.from(e.getSelectedBlocks()).filter(function (t) {
                return n.checkAttribute(t, "blockIndent");
              });
            }(t);
          t.change(function (t) {
            var _iterator = _createForOfIteratorHelper(e),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _n = _step.value;
                var _e = _n.getAttribute("blockIndent"),
                  _s = _this3._indentBehavior.getNextIndent(_e);
                _s ? t.setAttribute("blockIndent", _s, _n) : t.removeAttribute("blockIndent", _n);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          });
        }
      }]);
      return u;
    }(t.Command);
    var h = /*#__PURE__*/function () {
      function h(t) {
        _classCallCheck(this, h);
        this.isForward = "forward" === t.direction, this.offset = t.offset, this.unit = t.unit;
      }
      _createClass(h, [{
        key: "checkEnabled",
        value: function checkEnabled(t) {
          var e = parseFloat(t || 0);
          return this.isForward || e > 0;
        }
      }, {
        key: "getNextIndent",
        value: function getNextIndent(t) {
          var e = parseFloat(t || 0);
          if (!(!t || t.endsWith(this.unit))) return this.isForward ? this.offset + this.unit : void 0;
          var n = e + (this.isForward ? this.offset : -this.offset);
          return n > 0 ? n + this.unit : void 0;
        }
      }]);
      return h;
    }();
    var g = /*#__PURE__*/function () {
      function g(t) {
        _classCallCheck(this, g);
        this.isForward = "forward" === t.direction, this.classes = t.classes;
      }
      _createClass(g, [{
        key: "checkEnabled",
        value: function checkEnabled(t) {
          var e = this.classes.indexOf(t);
          return this.isForward ? e < this.classes.length - 1 : e >= 0;
        }
      }, {
        key: "getNextIndent",
        value: function getNextIndent(t) {
          var e = this.classes.indexOf(t),
            n = this.isForward ? 1 : -1;
          return this.classes[e + n];
        }
      }]);
      return g;
    }();
    var m = ["paragraph", "heading1", "heading2", "heading3", "heading4", "heading5", "heading6"];
    var f = /*#__PURE__*/function (_t$Plugin4) {
      _inherits(f, _t$Plugin4);
      function f(t) {
        var _this4;
        _classCallCheck(this, f);
        _this4 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, t)), t.config.define("indentBlock", {
          offset: 40,
          unit: "px"
        });
        return _this4;
      }
      _createClass(f, [{
        key: "init",
        value: function init() {
          var t = this.editor,
            e = t.config.get("indentBlock"),
            n = !e.classes || !e.classes.length,
            s = Object.assign({
              direction: "forward"
            }, e),
            i = Object.assign({
              direction: "backward"
            }, e);
          n ? (t.data.addStyleProcessorRules(c.addMarginRules), this._setupConversionUsingOffset(t.conversion), t.commands.add("indentBlock", new u(t, new h(s))), t.commands.add("outdentBlock", new u(t, new h(i)))) : (this._setupConversionUsingClasses(e.classes), t.commands.add("indentBlock", new u(t, new g(s))), t.commands.add("outdentBlock", new u(t, new g(i))));
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var t = this.editor,
            e = t.model.schema,
            n = t.commands.get("indent"),
            s = t.commands.get("outdent"),
            i = t.config.get("heading.options");
          (i && i.map(function (t) {
            return t.model;
          }) || m).forEach(function (t) {
            e.isRegistered(t) && e.extend(t, {
              allowAttributes: "blockIndent"
            });
          }), e.setAttributeProperties("blockIndent", {
            isFormatting: !0
          }), n.registerChildCommand(t.commands.get("indentBlock")), s.registerChildCommand(t.commands.get("outdentBlock"));
        }
      }, {
        key: "_setupConversionUsingOffset",
        value: function _setupConversionUsingOffset() {
          var t = this.editor.conversion,
            e = "rtl" === this.editor.locale.contentLanguageDirection ? "margin-right" : "margin-left";
          t.for("upcast").attributeToAttribute({
            view: {
              styles: _defineProperty({}, e, /[\s\S]+/)
            },
            model: {
              key: "blockIndent",
              value: function value(t) {
                return t.getStyle(e);
              }
            }
          }), t.for("downcast").attributeToAttribute({
            model: "blockIndent",
            view: function view(t) {
              return {
                key: "style",
                value: _defineProperty({}, e, t)
              };
            }
          });
        }
      }, {
        key: "_setupConversionUsingClasses",
        value: function _setupConversionUsingClasses(t) {
          var e = {
            model: {
              key: "blockIndent",
              values: []
            },
            view: {}
          };
          var _iterator2 = _createForOfIteratorHelper(t),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _n2 = _step2.value;
              e.model.values.push(_n2), e.view[_n2] = {
                key: "class",
                value: [_n2]
              };
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          this.editor.conversion.attributeToAttribute(e);
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "IndentBlock";
        }
      }]);
      return f;
    }(t.Plugin);
  })(), (window.CKEditor5 = window.CKEditor5 || {}).indent = s;
}();